import { EntryPoint } from './EntryPoint';

const getDP = (entryPoint, isDPTab, isWMP) => {
    let buyPath;

    if (isWMP && (entryPoint === EntryPoint.HOME || entryPoint === EntryPoint.FLIGHTS)) {
        buyPath = isDPTab ? BuyPath.HOME_PAGE_WMP_DP_TAB : BuyPath.HOME_PAGE_WMP_FLIGHTS_TAB;
    } else {
        buyPath =
            entryPoint === EntryPoint.HOME
                ? isDPTab
                    ? BuyPath.HOME_PAGE_DP_TAB
                    : BuyPath.HOME_PAGE_FLIGHTS_TAB_WITH_HOTEL
                : isDPTab
                    ? BuyPath.DP_PAGE_DP_TAB
                    : BuyPath.DP_PAGE_FLIGHTS_TAB_WITH_HOTEL;
    }

    return buyPath;
};

export const BuyPath = Object.freeze({
    INSPIRE_ME: 'INSPIRATIONAL_SEARCH', // 82
    FLIGHTS_PAGE: 'FLIGHTS_HOME_SEARCH_FORM', // 71
    FLIGHTS_EDIT: 'FLIGHTS_RESULTS_SEARCH_FORM', // 73

    HOME_RAIL_TAB: 'HOME_RAIL_TAB', // 51
    HOME_RAIL: 'HOME_RAIL', // 52

    HOME_PAGE_FLIGHTS_TAB: 'FLIGHTS_HOME_SEARCH_FORM', // 71
    HOME_PAGE_WMP_FLIGHTS_TAB: 'FLIGHTS_HOME_SEARCH_FORM_MICROSITE', // 99
    HOME_PAGE_FLIGHTS_TAB_WITH_HOTEL: 'FLIGHTS_HOME_FLIGHTS_TAB', // 5200
    HOME_PAGE_DP_TAB: 'FLIGHTS_HOME_DYNPACK_TAB', // 5201
    HOME_PAGE_FLIGHTS_TAB_WITH_HOTEL_MOBILE: 'DYNPACK_MOBILE_FLIGHTS_TAB', // 5208
    HOME_PAGE_WMP_DP_TAB: 'DYNPACK_HOME_DYNPACK_TAB_MICROSITE', // 5513

    DP_PAGE_FLIGHTS_TAB: 'FLIGHTS_HOME_SEARCH_FORM', // 71
    DP_PAGE_FLIGHTS_TAB_WITH_HOTEL: 'DYNPACK_HOME_FLIGHTS_TAB', // 5202
    DP_PAGE_DP_TAB: 'DYNPACK_HOME_DYNPACK_TAB', // 5203
    DP_PAGE_MOBILE: 'DYNPACK_MOBILE_HOME', // 5205

    HSA_HOME_TAB: 'HOME_HSA_TAB', // 7201
    HSA_HOME: 'HSA_HOME', // 7202
    HSA_MONITORING: 'HSA_MONITORING', // 7229
    HSA_PB_SEARCHEXTENSION: 'HSA_PB_SEARCHEXTENSION',
    HSA_CRM: 'HSA_CRM', // 7238
    HSA_LANDING_WMP: 'HSA_LANDING_WMP', // 7239
    HSA_WMP_HOME_TAB: 'HOME_HSA_TAB_MICROSITE', // 7275

    getDP,
});
